export const ADD_PERSON = 'ADD_PERSON';
export const ADD_PERSON_SUCCESS = 'ADD_PERSON_SUCCESS';
export const ADD_PERSON_FAILED = 'ADD_PERSON_FAILED';
export const FETCH_PEOPLE = 'FETCH_PEOPLE';
export const FETCH_PEOPLE_SUCCESS = 'FETCH_PEOPLE_SUCCESS';
export const FETCH_PEOPLE_FAILED = 'FETCH_PEOPLE_FAILED';
export const RESET_PERSON_ADDED = 'RESET_PERSON_ADDED';
export const EDIT_PERSON = 'EDIT_PERSON';
export const EDIT_PERSON_SUCCESS = 'EDIT_PERSON_SUCCESS';
export const EDIT_PERSON_FAILED = 'EDIT_PERSON_FAILED';
export const RESET_PERSON_EDITED = 'RESET_PERSON_EDITED';
export const FETCH_PERSON = 'FETCH_PERSON';
export const FETCH_PERSON_SUCCESS = 'FETCH_PERSON_SUCCESS';
export const FETCH_PERSON_FAILED = 'FETCH_PERSON_FAILED';
export const DELETE_PERSON = 'DELETE_PERSON';
export const DELETE_PERSON_SUCCESS = 'DELETE_PERSON_SUCCESS';
export const RESET_PERSON_DELETED = 'RESET_PERSON_DELETED';
export const DELETE_PERSON_FAILED = 'DELETE_PERSON_FAILED';
export const UPLOAD_PEOPLE_FROM_FILE = 'UPLOAD_PEOPLE_FROM_FILE';
export const UPLOAD_PEOPLE_FROM_FILE_SUCCESS =
  'UPLOAD_PEOPLE_FROM_FILE_SUCCESS';
export const PEOPLE_UPLOADED_FROM_FILE_RESET =
  'PEOPLE_UPLOADED_FROM_FILE_RESET';
export const UPLOAD_PEOPLE_FROM_FILE_FAILED = 'UPLOAD_PEOPLE_FROM_FILE_FAILED';
export const RESET_FILE_UPLOAD = 'RESET_FILE_UPLOAD';

export const UPLOAD_PEOPLE_FROM_FILE_CONFIRM =
  'UPLOAD_PEOPLE_FROM_FILE_CONFIRM';
export const UPLOAD_PEOPLE_FROM_FILE_CONFIRM_SUCCESS =
  'UPLOAD_PEOPLE_FROM_FILE_CONFIRM_SUCCESS';
export const UPLOAD_PEOPLE_FROM_FILE_CONFIRM_FAILED =
  'UPLOAD_PEOPLE_FROM_FILE_CONFIRM_FAILED';
export const RESET_PEOPLE_PAGE = 'RESET_PEOPLE_PAGE'



